
// 课程图片列表
Vue.component("course_picture_panel", {
  props: {
      player: {
          type: Object,
      },
      list: {
          type: Array,
          default: [],
      },
      framerate: {
          type: Number,
          default: 25
      },
      can_click: {
        type: Boolean,
        default: false
      }
  },
  data() {
      return {
          selected: ''
      };
  },
  methods: {
      playerSeek(pointIn) {
        if(!this.can_click) return this.$message.error(this.$t("请先完成第一遍学习"))
          this.player.currentTime = pointIn / 10000000;
          console.log(pointIn / 10000000)
          this.player.play();
      },
      handleSelect(item) {
          this.selected = item.fileGUID
          this.playerSeek(item.ns)
      }
  },
  computed: {
      listFormat() {
          const temp = JSON.parse(JSON.stringify(this.list));
          return (temp ? temp.sort((a, b) => a.keyFrameNo - b.keyFrameNo) : []).map(el => {
              el.timeFormat = window.TimeCodeConvert.frame2Tc(el.keyFrameNo, this.framerate, false).split(':').slice(0,-1).join(':')
              el.ns = window.TimeCodeConvert.frame2L100Ns(el.keyFrameNo, this.framerate)
              return el
          })
      }
  },
  template: `
      <div class="course_picture_panel">
          <el-empty v-if="!this.listFormat.length"></el-empty>
          <div v-else class="course_picture_list">
              <div class="course_picture_item" :class="{active:selected == item.fileGUID}" v-for="(item,i) in listFormat" :key="item.fileGUID" @click="handleSelect(item)">
                  <div class="item_left">
                      <div class="icon"></div>
                      <div class="time">{{item.timeFormat}}</div>
                  </div>
                  <div class="item_right">
                      <div class="index">{{i + 1}}</div>
                      <img :src="item.filePath" alt="">
                  </div>
              </div>
          </div>
      </div>
  `,
});